import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { adminService } from '../../../services/adminService';

const LoyaltyManagementSection = ({ shipment, clientLoyaltyPoints, onUpdate }) => {
  const [pointsToAdd, setPointsToAdd] = useState(0);
  const [updating, setUpdating] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleUpdatePoints = async (e) => {
    e?.preventDefault();
    if (pointsToAdd === 0) {
      setMessage({ type: 'error', text: 'Veuillez entrer un nombre de points' });
      return;
    }

    try {
      setUpdating(true);
      setMessage({ type: '', text: '' });
      await adminService?.updateClientLoyaltyPoints(shipment?.sender?.phone, parseInt(pointsToAdd));
      setMessage({ type: 'success', text: `${pointsToAdd} points ajoutés avec succès!` });
      setPointsToAdd(0);
      onUpdate();
    } catch (err) {
      setMessage({ type: 'error', text: err?.message });
      console.error('Error updating loyalty points:', err);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-4">Fidélité Client</h3>
      <div className="space-y-6">
        {/* Current Points Display */}
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-md">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Icon name="Award" size={32} className="text-yellow-600" />
              <div>
                <p className="text-sm text-gray-600">Points actuels du client</p>
                <p className="text-3xl font-bold text-yellow-600">{clientLoyaltyPoints || 0}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Add Points Form */}
        <form onSubmit={handleUpdatePoints} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Ajouter des points
            </label>
            <div className="flex space-x-3">
              <Input
                type="number"
                min="-1000"
                max="1000"
                value={pointsToAdd}
                onChange={(e) => setPointsToAdd(e?.target?.value)}
                placeholder="Ex: 5 ou -5 pour retirer"
                className="flex-1"
              />
              <Button type="submit" disabled={updating} className="px-6">
                {updating ? 'Mise à jour...' : 'Mettre à jour'}
              </Button>
            </div>
            <p className="mt-2 text-xs text-gray-500">
              Entrez un nombre positif pour ajouter des points, ou négatif pour en retirer
            </p>
          </div>
        </form>

        {/* Message Display */}
        {message?.text && (
          <div className={`p-4 rounded-md ${
            message?.type === 'success' ?'bg-green-50 border border-green-200' :'bg-red-50 border border-red-200'
          }`}>
            <div className="flex items-center space-x-2">
              <Icon 
                name={message?.type === 'success' ? 'CheckCircle' : 'AlertCircle'} 
                size={20} 
                className={message?.type === 'success' ? 'text-green-600' : 'text-red-600'} 
              />
              <p className={`text-sm ${
                message?.type === 'success' ? 'text-green-800' : 'text-red-800'
              }`}>
                {message?.text}
              </p>
            </div>
          </div>
        )}

        {/* Info Section */}
        <div className="p-4 bg-blue-50 border border-blue-200 rounded-md">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={20} className="text-blue-600 mt-0.5" />
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-1">Système de fidélité</p>
              <ul className="space-y-1">
                <li>• Les points sont automatiquement attribués lors de la création d'un envoi</li>
                <li>• Utilisez cette section pour ajuster manuellement les points</li>
                <li>• Les clients peuvent échanger leurs points contre des réductions</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyManagementSection;